import React from "react";

import verificationIcon from "../../media/icons/Verification.png";
import doNotSellIcon from "../../media/icons/DoNotSell.png";
import deleteMyInfoIcon from "../../media/icons/DeleteMyInfo.png";
import accessMyInfoIcon from "../../media/icons/AccessMyInfo.png";
import correctData from "../../media/icons/CorrectData.png";
import errorIcon from "../../media/icons/Error.png";
import secureKeyInteracEng from "../../media/icons/SKInteracEng.png";
import secureKeyInteracFr from "../../media/icons/SKInteracFR.png";

import "./icons.css";

export const VerificationIcon = () => {
    return(
        <div className='main-class'>
            <img className='sub-class' src={verificationIcon} alt='verificationIcon' />
        </div>
    )
}

export const DoNotSellIcon = () => {
    return(
        <div className='main-class'>
            <img className='sub-class' src={doNotSellIcon} alt='doNotSellIcon' />
        </div>
    )
}

export const DeleteMyInfoIcon = () => {
    return(
        <div className='main-class'>
            <img className='sub-class' src={deleteMyInfoIcon} alt='deleteMyInfoIcon' />
        </div>
    )
}

export const AccessMyInfoIcon = () => {
    return(
        <div className='main-class'>
            <img className='sub-class' src={accessMyInfoIcon} alt='accessMyInfoIcon' />
        </div>
    )
}

export const CorrectMyInfoIcon = () => {
    return(
        <div className='main-class'>
            <img className='sub-class' src={correctData} alt='correctMyInfoIcon' />
        </div>
    )
}

export const ErrorIcon = () => {
    return(
        <div className='main-class'>
            <img className='sub-class' src={errorIcon} alt='errorIcon' />
        </div>
    )
}

export const SKInteracEng = () => {
    return(
        <div className='main-class'>
            <img src={secureKeyInteracEng} alt='errorIcon' />
        </div>
    )
}

export const SKInteracFr = () => {
    return(
        <div className='main-class'>
            <img src={secureKeyInteracFr} alt='errorIcon' />
        </div>
    )
}